import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Input, Button, ButtonToolbar, Modal} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm} from '../../core/redux/form'
import LoaderButton from '../../core/components/LoaderButton'
import ActivityPicker from '../../reference/components/ActivityPicker'
import {AssignActivityToProviderCompanyCmd} from '../models'
import {ASSIGN_ACTIVITY_TO_PROVIDER_COMPANY_CMD_UPDATED, sendAssignActivityToProviderCompanyCmd, sendDefineUpdateInterventionPeriodForActivityCmd, sendDefineInterventionZoneForInterventionPeriodCmd, sendDefineServiceChargeForInterventionPeriodCmd, sendDefineCallOutChargesForInterventionPeriodCmd, sendSubscribeProviderCompanyToDirectoryForInterventionPeriodCmd, loadProvider} from '../actions'
import i18n from '../i18n'

function activityAggregator(reference) {
    return (result, activity) => {
        const resultActivity = reference.find((a) => a.uid == activity.activityUid)
        if (resultActivity) {
            const aggrega = {
                activity: resultActivity,
                interventionPeriods: activity.interventionPeriods
            }

            result.push(aggrega)
        } else {
            console && console.warn('activity "' + activity.activityUid + '" doesn\'t exist in referentiel')
        }
        return result
    }
}

function copyInterventionPeriodCmd(interventionPeriod) {
    return {
        period: interventionPeriod.period,
        commandType: 'DefineInterventionPeriodForActivity'
    }
}

function copyServiceChargeCmd(interventionPeriod) {
    return {
        charge: interventionPeriod.serviceCharge
    }
}

function copyInterventionZoneCmd(interventionPeriod) {
    return {
        zone: interventionPeriod.interventionZone
    }
}

function copyCallOutChargesCmd(interventionPeriod) {
    return {
        callOutCharges: interventionPeriod.callOutCharges
    }
}

function copySubscriptionsCmd(interventionPeriod) {
    return {
        subscriptions: interventionPeriod.subscriptions
    }
}

class AssignActivityToProviderCompanyModal extends Component {
    static propTypes = {
        onHide: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    componentWillMount() {
        const {activityReference, provider} = this.props

        const activityAggregation = provider.activities.reduce(activityAggregator(activityReference), [])
        this.setState({activityAggregation})
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.activityReference != this.props.activityReference
            || nextProps.provider != this.props.provider) {
            const {activityReference, provider} = nextProps

            const activityAggregation = provider.activities.reduce(activityAggregator(activityReference), [])
            this.setState({activityAggregation})
        }
    }

    _sendCmd(event) {
        const {dispatch, cmd, provider, onHide} = this.props
        const {activeAggrega} = this.state

        function sendCopyInterventionPeriodCmds(interventionPeriod) {
            var interventionPeriodCopyUid
            
            return dispatch(sendDefineUpdateInterventionPeriodForActivityCmd(provider._links, activity.uid, copyInterventionPeriodCmd(interventionPeriod))).then((action) => {
                interventionPeriodCopyUid = action.events.find((e) => e.eventType == 'InterventionPeriodDefinedForActivity').period.uid
                return interventionPeriod.interventionZone && dispatch(sendDefineInterventionZoneForInterventionPeriodCmd(provider._links, activity.uid, interventionPeriodCopyUid, copyInterventionZoneCmd(interventionPeriod)))
            }).then(() => {
                return interventionPeriod.serviceCharge && dispatch(sendDefineServiceChargeForInterventionPeriodCmd(activity.uid, interventionPeriodCopyUid, copyServiceChargeCmd(interventionPeriod)))
            }).then(() => {
                return interventionPeriod.callOutCharges.length > 0 && dispatch(sendDefineCallOutChargesForInterventionPeriodCmd(activity.uid, interventionPeriodCopyUid, copyCallOutChargesCmd(interventionPeriod)))
            }).then(() => {
                return interventionPeriod.subscriptions.length > 0 && dispatch(sendSubscribeProviderCompanyToDirectoryForInterventionPeriodCmd(activity.uid, interventionPeriodCopyUid, copySubscriptionsCmd(interventionPeriod)))
            })
        }

        const activity = cmd && cmd.activityUid
        return dispatch(sendAssignActivityToProviderCompanyCmd()).then(() => {
            // copy selected activity
            // we have to execute all cmds sequencialy to avoid backend issues
            return activeAggrega && activeAggrega.interventionPeriods.reduce((result, interventionPeriod) => {
                return result.then(() => sendCopyInterventionPeriodCmds(interventionPeriod))
            }, Promise.resolve())
        }).then(() => {
            return dispatch(loadProvider())
        }).then(() => {
            onHide(event, 'ActivityAssignedToProviderCompany', activity)
        })
    }

    render() {
        const {dispatch, form, cmd, activityReference, provider, onHide, ...others} = this.props
        const {activityAggregation, activeAggrega} = this.state

        const requiredLabel = (label) => (
            <span>{label} <i>*</i></span>
        )

        const activeAggregaField = () => {
            const value = activeAggrega && activeAggrega.activity.uid || ''

            const onChange = (event) => {
                const activeAggregaId = event.target.value || null
                const activeAggrega = activeAggregaId && activityAggregation.find((a) => a.activity.uid == activeAggregaId)
                this.setState({activeAggrega})
            }

            return {value, onChange}
        }

        const displayActivity = (activity, mode) => {
            if (mode == 'Picked') {
                return (
                    <div>
                        <h4>{activity.label}</h4>
                        <form>
                            <Input
                                type='select'
                                name='activity'
                                {...activeAggregaField()}>
                                <option value=''>{i18n.copyActivity} ...</option>
                                {activityAggregation.map((aggrega, index) => (
                                    <option
                                        key={index}
                                        value={aggrega.activity.uid}>
                                        {aggrega.activity.label}
                                    </option>
                                ))}
                            </Input>
                        </form>
                    </div>
                )
            }

            return activity.label
        }

        return (
            <Modal
                onHide={onHide}
                {...others}>
                <Modal.Header>
                    <Modal.Title>{i18n.assignActivity}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ActivityPicker
                        display={displayActivity}
                        disable={(a) => activityAggregation.find((ag) => ag.activity.uid == a.uid)}
                        {...form.activityUid()} />
                    <ButtonToolbar>
                        <LoaderButton
                            bsStyle='primary'
                            bsSize='large'
                            className={cx({disabled: !form.isValid()})}
                            onClick={(e) => form.validate() && this._sendCmd(e) || dispatch(errorStatus(i18n.formInvalid))}>
                            {i18n.save}
                        </LoaderButton>
                        <Button
                            bsSize='large'
                            onClick={onHide}>
                            {i18n.cancel}
                        </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        )
    }
}

AssignActivityToProviderCompanyModal = connectForm({
    target: 'cmd',
    schema: AssignActivityToProviderCompanyCmd.schema,
    action: ASSIGN_ACTIVITY_TO_PROVIDER_COMPANY_CMD_UPDATED
})(AssignActivityToProviderCompanyModal)

AssignActivityToProviderCompanyModal = connect((state) => ({
    provider: state.provider.provider,
    activityReference: state.reference.activityRef,
    cmd: state.provider.assignActivityToProviderCompanyCmd
}))(AssignActivityToProviderCompanyModal)

export default AssignActivityToProviderCompanyModal


// WEBPACK FOOTER //
// ./lib/provider/components/AssignActivityToProviderCompanyModal.js